import { render, staticRenderFns } from "./VatNumberBlock.vue?vue&type=template&id=2a450688&scoped=true"
import script from "./VatNumberBlock.vue?vue&type=script&lang=js"
export * from "./VatNumberBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a450688",
  null
  
)

export default component.exports